import useFilterData from "@/hooks/useFIlterData"
import BannerCallToActionModule from "@/components/BannerCallToActionModule/index"

export default function Preview({ data }) {
	const allBanners = data?.banners || []
	const filteredData = useFilterData(allBanners)

	if (!filteredData) return null

	return <BannerCallToActionModule data={filteredData} />
}
